import { del, get, patch, post, Response } from '@/api'
import {
  Cart,
  CartItemMoveDto,
  CartItemMoveInfo,
  CartItemPostDto,
  CartItemsCount,
  CartOptimizationResult,
  CartPatchDto,
  OptimizationStrategy,
  OptimizationType,
  SupplierCart
} from '@/types/index'

export default {
  loadCart: (realtime = false, vatCountry?: string): Promise<Response<Cart>> => {
    return get<Cart>('/carts', {
      params: {
        realtime,
        iso3country: vatCountry
      }
    })
  },

  loadSupplierCart: (
    id: string,
    realtime = false,
    vatCountry?: string
  ): Promise<Response<SupplierCart>> => {
    return get<SupplierCart>('/carts/' + id, {
      params: {
        realtime,
        iso3country: vatCountry
      }
    })
  },

  loadCartCount: (): Promise<Response<CartItemsCount>> => {
    return get<CartItemsCount>('/carts/items/count')
  },

  loadCartItemMoveInfo: (): Promise<Response<CartItemMoveInfo>> => {
    return get<CartItemMoveInfo>('/carts/items/move')
  },

  addCartItem: (item: CartItemPostDto): Promise<Response<string>> => {
    return post<string, CartItemPostDto>('/carts/items', item)
  },

  moveCartItem: (id: string, dto: CartItemMoveDto): Promise<Response<string>> => {
    return post<string, CartItemMoveDto>('/carts/items/' + id + '/move', dto)
  },

  removeCartItem: (id: string): Promise<Response<string>> => {
    return del<string>('/carts/items/' + id)
  },

  emptyCart: (): Promise<Response<string>> => {
    return post<string, null>('/carts/actions/empty')
  },

  createQuoteRequest: (): Promise<Response<string>> => {
    return post<string, null>('/carts/actions/request-quote')
  },

  patchCartItem: (id: string, item: CartPatchDto): Promise<Response<string>> => {
    return patch<string, CartPatchDto>('/carts/items/' + id, item)
  },

  getCartOptimizations: (): Promise<Response<OptimizationType[]>> => {
    return get<OptimizationType[]>('/carts/optimizations')
  },

  calculateCartOptimizations: (): Promise<Response<CartOptimizationResult[]>> => {
    return get<CartOptimizationResult[]>('/carts/optimizations/preview')
  },

  optimizeCart: (strategy: OptimizationStrategy): Promise<Response<string>> => {
    return post<string, null>('/carts/optimizations/apply', null, {
      params: {
        strategy
      }
    })
  }
}
